const smallScreen = window.matchMedia('(max-width: 1279px)');
const largeScreen = window.matchMedia('(min-width: 1280px)');

export default class Menu {
    constructor(component) {
        this.component = component;
        this.triggerOpen = this.component.querySelector('[data-menu-open]');
        this.triggerClose = this.component.querySelector('[data-menu-close]');
        this.nav = this.component.querySelector('[data-menu-nav]');
        this.searchButton = this.component.querySelector('[data-menu-search-button]');
        this.searchInput = this.component.querySelector('[data-menu-search-input]');
        this.mainLinks = document.querySelectorAll('[data-nav-main] [data-component="showhide"]');
        this.subLinks = document.querySelectorAll(
            '[data-nav-sub] [data-submenu] [data-component="showhide"]'
        );
        this.subLinkFirstLevel = document.querySelector(
            '[data-nav-sub] [data-submenu]:first-child [data-component="showhide"]'
        );
        this.currentMainLink = this.mainLinks[0];
        this.currentSubLink = this.subLinks[0];

        this.init();
    }

    switchLink(clickedLink, currentLink) {
        if (!clickedLink) return;

        clickedLink.classList.add('is-highlighted');

        if (currentLink) {
            currentLink.classList.remove('is-highlighted');
            return clickedLink;
        }
        return currentLink;
    }

    getSubLink(link) {
        const showTargets = link.getAttribute('data-showhide-show');
        if (!showTargets) return;

        const submenuSelector = showTargets.split(',').find((x) => x.includes('data-submenu'));
        if (!submenuSelector) return;

        return document.querySelector(`${submenuSelector} [data-component="showhide"]`);
    }

    init() {
        this.triggerOpen.addEventListener('click', () => {
            document.body.style.overflowY = 'hidden';

            if (largeScreen.matches) {
                if (this.mainLinks) this.mainLinks[0].click();
                if (this.subLinkFirstLevel) this.subLinkFirstLevel.click();
            }
        });

        this.searchButton.addEventListener('click', () => {
            if (smallScreen.matches && this.searchInput) {
                this.searchInput.focus();
            }
        });

        this.triggerClose.addEventListener('click', () => {
            document.body.style.overflowY = 'auto';

            this.component.querySelectorAll('is-highlighted').forEach((activeLink) => {
                activeLink.classList.remove('is-highlighted');
            });

            if (smallScreen.matches) {
                document
                    .querySelectorAll('[data-nav-sub].is-active, [data-nav-supersub].is-active')
                    .forEach((element) => {
                        element.classList.remove('is-active');
                    });
            }
        });

        this.component.addEventListener('click', (event) => {
            const trigger = event.target.closest('[data-component="showhide"]');

            if (
                this.nav.classList.contains('is-active') &&
                !event.target.closest('[data-menu-element]')
            ) {
                this.triggerClose.click();
            }

            if (trigger) {
                if (trigger.closest('[data-nav-main]')) {
                    this.currentMainLink = this.switchLink(trigger, this.currentMainLink);
                    this.currentSubLink = this.switchLink(
                        this.getSubLink(trigger),
                        this.currentSubLink
                    );
                }

                if (trigger.closest('[data-nav-sub]')) {
                    this.currentSubLink = this.switchLink(trigger, this.currentSubLink);
                }
            }
        });
    }
}
